import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { LeaderboardStat, LeaderboardStatPeriod, LeagueFilter, Period } from 'models';

interface Props {
  selectedLeague: LeagueFilter;
  onLeagueChange: (league: LeagueFilter) => void;
  selectedPeriod: Period;
  onPeriodChange: (period: Period) => void;
  stat?: LeaderboardStatPeriod;
  date?: string;
}

const LeaderboardFilter = ({ selectedLeague, selectedPeriod, onLeagueChange, onPeriodChange, stat, date }: Props) => {
  const handleLeagueFilterClick = (league: LeagueFilter) => {
    onLeagueChange(league);
  };

  const handlePeriodChange = (period: Period) => {
    onPeriodChange(period);
  };

  const period = (selectedPeriod: Period, date: string) => {
    if (!date) return '';

    const now = dayjs().tz('America/Los_Angeles');
    const baseDate = dayjs(date);
    let start, end;

    if (selectedPeriod === 'monthly') {
      start = baseDate.startOf('month');
      end = baseDate.endOf('month');
    } else if (selectedPeriod === 'weekly') {
      start = baseDate.startOf('week');
      end = baseDate.endOf('week');
    }

    const isCurrent = now.isBetween(start, end, 'day', '[]');

    if (isCurrent) {
      const daysLeft = end?.diff(now, 'day');
      return `${daysLeft} days left`;
    } else {
      return `${start?.format('MMM D')} - ${end?.format('MMM D')}`;
    }
  };

  const getLeagueDisplayName = (league: LeagueFilter) => {
    switch (league) {
      case 'nba':
        return 'NBA';
      case 'nfl':
        return 'NFL';
      case 'mlb':
        return 'MLB';
      case 'wnba':
        return 'WNBA';
      case 'all':
        return 'ALL';
      default:
        return league;
    }
  };

  return (
    <Flex
      w="100%"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
      mt="8px"
      mb="14px"
      backgroundColor="#292929"
    >
      <Flex
        w="100%"
        px="15px"
        gap="12px"
        alignItems="center"
        borderTop="1px solid rgba(51, 51, 51, 1)"
        borderBottom="1px solid rgba(51, 51, 51, 1)"
        pt="12px"
        pb="12px"
      >
        {(['all', 'nba', 'nfl', 'mlb', 'wnba'] as LeagueFilter[]).map((league) => (
          <Box
            key={league}
            fontFamily="Special Gothic Expanded One"
            fontSize="12px"
            textTransform="uppercase"
            fontWeight="400"
            lineHeight="1.2"
            cursor="pointer"
            transition="opacity 0.3s ease-in-out"
            color={selectedLeague === league ? '#F83C3C' : 'white'}
            onClick={() => handleLeagueFilterClick(league)}
          >
            {getLeagueDisplayName(league)}
          </Box>
        ))}
      </Flex>

      <Flex
        w="100%"
        px="15px"
        gap="12px"
        alignItems="center"
        borderBottom="1px solid rgba(51, 51, 51, 1)"
        pb="12px"
        pt="12px"
      >
        {/* <SortIcon
      style={{
        width: '12px',
        height: '12px',
      }}
    /> */}
        <Flex gap="12px">
          <Box
            fontFamily="Special Gothic Expanded One"
            fontSize="12px"
            textTransform="uppercase"
            fontWeight="400"
            lineHeight="1.2"
            cursor="pointer"
            transition="opacity 0.3s ease-in-out"
            color={selectedPeriod === 'monthly' ? '#F83C3C' : 'rgba(255, 255, 255, 1)'}
            onClick={() => handlePeriodChange('monthly')}
          >
            monthly
          </Box>
          <Box
            fontFamily="Special Gothic Expanded One"
            fontSize="12px"
            textTransform="uppercase"
            fontWeight="400"
            lineHeight="1.2"
            cursor="pointer"
            transition="opacity 0.3s ease-in-out"
            color={selectedPeriod === 'weekly' ? '#F83C3C' : 'rgba(255, 255, 255, 1)'}
            onClick={() => handlePeriodChange('weekly')}
          >
            weekly
          </Box>
        </Flex>
        <Box
          fontFamily="Special Gothic Expanded One"
          fontSize="12px"
          textTransform="uppercase"
          fontWeight="400"
          lineHeight="1.2"
          marginLeft="auto"
          color="rgba(255, 165, 0, 1)"
        >
          {period(selectedPeriod, date || '')}
        </Box>
      </Flex>
    </Flex>
  );
};

export default LeaderboardFilter;
